import ServerConnector from "../utils/ServerConnector";

export const setUserUiOnboardingLevel = async (onboardingLevel) => {
  try {
    const response = await ServerConnector.post(
      "/user/set/ui-onboarding-level",
      { currentUiOnboardingLevel: onboardingLevel },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err.response;
  }
};
